module.exports = __webpack_public_path__ + "img/icon8.8a57a979.svg";